import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { StatusCheckListType } from '../../pages/supplier/status-check/StatusCheck'

export interface StatusCheckState {
  /** 検索条件  */
  statusCheckSearch: {
    simulationY: string
    simulationM: string
    branchCdList: string[]
    expenseCd: string
    supplierNm: string
    replyStsCdList: string[]
    sortOrder: string
    matrixTransitionFlg: boolean
  }
  statusCheckList: StatusCheckListType['statusCheckList']
  // スキップ明細数
  skip: number
  // 選択業者
  target: string
}

const initialState: StatusCheckState = {
  statusCheckSearch: {
    simulationM: (new Date().getMonth() + 1).toString(),
    simulationY: new Date().getFullYear().toString(),
    branchCdList: [],
    expenseCd: '',
    supplierNm: '',
    replyStsCdList: [],
    sortOrder: '1',
    matrixTransitionFlg: false
  },
  statusCheckList: [],
  skip: 0,
  target: ''
}

const statusCheckSlice = createSlice({
  name: 'statuscheck',
  initialState,
  reducers: {
    setStatusCheckSearch: (
      state,
      action: PayloadAction<StatusCheckState['statusCheckSearch']>
    ) => {
      state.statusCheckSearch = action.payload
    },
    setStatusCheckList: (
      state,
      action: PayloadAction<StatusCheckListType['statusCheckList']>
    ) => {
      state.statusCheckList = action.payload
    },
    setReplyReqFlg: (
      state,
      action: PayloadAction<{
        arrayIndex: number
        value: number
      }>
    ) => {
      state.statusCheckList[action.payload.arrayIndex].replyReqFlg =
        action.payload.value
    },
    setHearingSheetFlg: (
      state,
      action: PayloadAction<{
        arrayIndex: number
        value: number
      }>
    ) => {
      state.statusCheckList[action.payload.arrayIndex].hearingSheetFlg =
        action.payload.value
    },
    setOutPutFlg: (
      state,
      action: PayloadAction<{
        arrayIndex: number
        value: number
      }>
    ) => {
      state.statusCheckList[action.payload.arrayIndex].outPutFlg =
        action.payload.value
    },
    setSkip: (
      state,
      action: PayloadAction<number>
    ) => {
      state.skip = action.payload
    },
    setTarget: (
      state,
      action: PayloadAction<string>
    ) => {
      state.target = action.payload
    }
  }
})

export const StatusCheckActions = statusCheckSlice.actions
export const StatusCheckReducers = statusCheckSlice.reducer
